















































































































	import { Component, Vue } from 'vue-property-decorator'
	import Slick from 'vue-slick'
	import $ from 'jquery'
	import * as VasilKov from '@/assets/scripts/SliderVasilkovModule'

	@Component({
		name: 'Vasilkov',
        components: { Slick }
	})
	export default class Vasilkov extends Vue {
		data() {
			return {
				title: 'Vasilkov slider',
				SlickOptions: {
					infinite: true,
					speed: 700,
					fade: true,
					waitForAnimate: true,
					cssEase: 'cubic-bezier(1,0,1,0)',
					responsive: [
						// You can unslick at a given breakpoint now by adding:
						// settings: "unslick"
						// instead of a settings object
					]
				}
			}
		}
		mounted() {
			new VasilKov.vasilkovModule(null, null, null, null, null)
		}
		runEvent(event, slick) {
			new VasilKov.vasilkovModule(event, slick, event.type, null, null)
        }

        beforeChange(event, slick, currentSlide, nextSlide) {
            new VasilKov.vasilkovModule(event, slick, event.type, currentSlide, nextSlide)
		}
        
	}
